'use client'

// Next.js
import Image from 'next/image'

// Utils
import { Join } from '../../lib/utils'

interface ThemeImageClientProps {
  lightSrc: string
  darkSrc: string
  alt: string
  className?: string
  width?: number
  height?: number
  priority?: boolean
}

export function ThemeImageClient({
  lightSrc,
  darkSrc,
  alt,
  className,
  width,
  height,
  priority = false,
}: ThemeImageClientProps) {
  return (
    <div
      className={Join(
        'flex justify-center',
        className !== undefined
          ? className
          : 'my-12 overflow-hidden rounded-sm px-4',
      )}
      style={{ fontSize: 0, lineHeight: 0 }}
    >
      <Image
        src={lightSrc}
        alt={alt}
        width={width || 800}
        height={height || 600}
        className="block h-auto w-full align-top dark:hidden"
        priority={priority}
      />
      <Image
        src={darkSrc}
        alt={alt}
        width={width || 800}
        height={height || 600}
        className="hidden h-auto w-full align-top dark:block"
        priority={priority}
      />
    </div>
  )
}
